import { render, staticRenderFns } from "./VForm.vue?vue&type=template&id=65bff210&scoped=true"
import script from "./VForm.vue?vue&type=script&lang=js"
export * from "./VForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bff210",
  null
  
)

export default component.exports